import React, { Fragment, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { withTranslator } from '../../../Translator/Translator';

const TextRenderer = ({ count, text }) => <>
    <strong>{count}</strong> {text}
  </>

export const CharacterCounter = ({ className, max, t, value }) => {
  const currentCount = (value && value.length) || 0;
  const classes = cn(
    'c-character-counter',
    {
      'is-too-long': currentCount > max,
    },
    className
  );

  const rendererProps =
    max <= currentCount
      ? { count: currentCount - max, text: t('characters over limit') }
      : { count: max - currentCount, text: t('characters remaining') };

  return (
    <span className={classes}>
      <TextRenderer {...rendererProps} />
    </span>
  );
};

CharacterCounter.PropTypes = {
  className: PropTypes.string,
  limit: PropTypes.number,
  t: PropTypes.func,
  value: PropTypes.string,
};

export default withTranslator(CharacterCounter);
